<template>
    <li >
        <span @click="handleClick">{{action.title}}</span>
    </li>
</template>

<script>
    import {mapActions, mapMutations} from 'vuex'
    import ConfirmComponent from "../common/ConfirmComponent";

    export default {
        name: 'controls-dropdown-item',
        props: {
            itemId: Number,
            visibleControls: Number,
            action: Object
        },
        methods: {
            ...mapActions([
                'switchPopup'
            ]),
            ...mapMutations([
                'setPopupComponent',
                'setConfirmAction',
            ]),
            handleClick() {
                if (this.action.needConfirm) {
                    this.setConfirmAction({action: this.action.action, payload: this.itemId, text: this.action.textConfirm});
                    this.setPopupComponent(ConfirmComponent);
                    this.switchPopup(true);
                } else {
                    this.$store.dispatch(this.action.action, this.itemId);
                }
            }
        },
    }
</script>

<style scoped>

</style>
